export const CalendarDataFromExercise = {
  'feeling-estimation': {
    'Not well':
      {
        image: require('../../pages/WorkoutFeedback/workout-feedback-img/not-well-img.png'),
        description:
          'You felt bad after the workout.',
      },
    'I’m OK':
      {
        image: require('../../pages/WorkoutFeedback/workout-feedback-img/ok-img.png'),
        description:
          'You felt OK after the workout.',
      },
    'Not tired':
      {
        image: require('../../pages/WorkoutFeedback/workout-feedback-img/not-tired-img.png'),
        description:
          'You felt great after the workout.',
      },
  },

  'workout-exertion': {
    'Difficult':
      {
        description: 'The workout was difficult for you, we recommend to lower the intensity.',
      },
    'Perfect':
      {
        description: 'The workout is perfect for you, we recommend not to change the intensity.',
      },
    'Too easy':
      {
        description: 'The workout was easy for you, we recommend to increase the intensity.',
      },
  },

  'training-images': {
    'Morning Routine': require('../../pages/WorkoutPage/img-workout/avocadoes/avocado-morning.png'),
    'Hips, Butt and Thighs': require('../../pages/WorkoutPage/img-workout/avocadoes/avocado-hips.png'),
    'Burn Belly Fat': require('../../pages/WorkoutPage/img-workout/avocadoes/avocado-burn.png'),
    'Full-Body Workout': require('../../pages/WorkoutPage/img-workout/avocadoes/avocado-full-body.png'),
    'Toned Arms and Chest': require('../../pages/WorkoutPage/img-workout/avocadoes/avocado-toned-arms.png'),
    'Maximum Weight Loss': require('../../pages/WorkoutPage/img-workout/avocadoes/avocado-maximum-weight-loss.png'),
  }
}